import React, { useState, useEffect, useRef } from 'react';
import type { Editor } from '@tiptap/core';

interface LinkDialogProps {
  editor: Editor;
  onClose: () => void;
}

export const LinkDialog: React.FC<LinkDialogProps> = ({ editor, onClose }) => {
  const currentHref = editor.getAttributes('link').href || '';
  const [url, setUrl] = useState(currentHref);
  const [openInNewTab, setOpenInNewTab] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!url) {
      editor.chain().focus().unsetLink().run();
    } else {
      const normalizedUrl = url.startsWith('http') || url.startsWith('mailto:') ? url : `https://${url}`;
      editor.chain().focus().setLink({
        href: normalizedUrl,
        target: openInNewTab ? '_blank' : undefined,
      }).run();
    }

    onClose();
  };

  const handleRemove = () => {
    editor.chain().focus().unsetLink().run();
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-content">
        <h3>Insert Link</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="link-url">URL</label>
            <input
              ref={inputRef}
              id="link-url"
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com"
            />
          </div>
          <div className="form-group checkbox">
            <label>
              <input
                type="checkbox"
                checked={openInNewTab}
                onChange={(e) => setOpenInNewTab(e.target.checked)}
              />
              Open in new tab
            </label>
          </div>
          <div className="dialog-actions">
            {currentHref && (
              <button type="button" className="btn-danger" onClick={handleRemove}>
                Remove Link
              </button>
            )}
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              {currentHref ? 'Update' : 'Insert'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LinkDialog;
